module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vendorUsersList"
  }, [_c('v-content', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('center', [(_vm.vendorLoaded == false) ? _c('img', {
    staticClass: "imgLoader",
    attrs: {
      "src": require("../../shared/assets/images/3dloader.gif")
    }
  }) : _vm._e()]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": "",
      "searchVendorPanel": ""
    }
  }, [_c('div', {
    staticClass: "relative"
  }, [(_vm.search != '') ? _c('a', {
    staticClass: "searchTypeClear",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncClearSearch.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons searchTypeClearText"
  }, [_vm._v("close")])]) : _vm._e(), _vm._v(" "), (_vm.vendorLoaded == true && _vm.search != '') ? _c('v-text-field', {
    attrs: {
      "label": "Search",
      "solo": "",
      "single-line": ""
    },
    on: {
      "input": _vm.fncFilterUsers
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.vendorLoaded == true && _vm.search == '') ? _c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "solo": "",
      "single-line": ""
    },
    on: {
      "input": _vm.fncFilterUsers
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }) : _vm._e(), _c('br')], 1)]), _vm._v("\n      " + _vm._s(_vm.vendorList) + "\n      "), (_vm.vendorLoaded == true) ? _c('v-data-table', {
    staticClass: "elevation-1 mainTable",
    attrs: {
      "headers": _vm.headers,
      "id": "hello",
      "items": _vm.filteredUsers,
      "hide-actions": "",
      "disable-initial-sort": "",
      "rows-per-page-items": [2000, 40, 60, 80, 100]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [(props.expanded == true) ? _c('td', {
          attrs: {
            "width": "25%"
          },
          on: {
            "click": function($event) {
              props.expanded = !props.expanded
            }
          }
        }, [(props.item.branch.length > 0 && _vm.search == '') ? _c('i', {
          staticClass: "material-icons showHide"
        }, [_vm._v("arrow_downward")]) : _vm._e(), _vm._v(_vm._s(props.item.label))]) : _c('td', {
          attrs: {
            "width": "25%"
          },
          on: {
            "click": function($event) {
              props.expanded = !props.expanded
            }
          }
        }, [(props.item.branch.length > 0 && _vm.search == '') ? _c('i', {
          staticClass: "material-icons showHide"
        }, [_vm._v("arrow_forward")]) : _vm._e(), _vm._v(_vm._s(props.item.label))]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "20%"
          }
        }, [_vm._v(_vm._s(props.item.vendorName))]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "20%"
          }
        }, [_vm._v(_vm._s(props.item.contactno))]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "20%"
          }
        }, [_vm._v(_vm._s(props.item.email))]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "10%"
          }
        }, [_c('v-menu', {
          attrs: {
            "offset-y": ""
          }
        }, [_c('v-toolbar-side-icon', {
          attrs: {
            "slot": "activator"
          },
          slot: "activator"
        }), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncLinkUsers(props.item.id)
            }
          }
        }, [_c('v-list-tile-title', [(_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('a', [_vm._v("Link Users")]) : _vm._e()])], 1), _vm._v(" "), _c('v-list-tile', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncEditPassword(props.item.id, props.item.email)
            }
          }
        }, [_c('v-list-tile-title', [(_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('a', [_vm._v("Update Password")]) : _vm._e()])], 1), _vm._v(" "), _c('v-list-tile', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncEditNotifications(props.item.id)
            }
          }
        }, [_c('v-list-tile-title', [(_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('a', [_vm._v("Communication Settings")]) : _vm._e()])], 1), _vm._v(" "), _c('v-list-tile', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncViewUser(props.item.id, props.item.region)
            }
          }
        }, [_c('v-list-tile-title', [(_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('a', [_vm._v("User Details")]) : _vm._e()])], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('td', {
          attrs: {
            "width": "5%"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncEditUser(props.item)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("edit")])])]) : _vm._e()])]
      }
    }, {
      key: "expand",
      fn: function(props) {
        return [(props.item.branch != '') ? _c('v-data-table', {
          staticClass: "elevation-1 subTable subTable1",
          attrs: {
            "headers": _vm.headers,
            "items": props.item.branch,
            "hide-actions": "",
            "disable-initial-sort": "",
            "rows-per-page-items": [20, 40, 60, 80, 100]
          },
          scopedSlots: _vm._u([{
            key: "items",
            fn: function(props) {
              return [_c('tr', [(props.expanded == true) ? _c('td', {
                attrs: {
                  "width": "45%"
                },
                on: {
                  "click": function($event) {
                    props.expanded = !props.expanded
                  }
                }
              }, [(props.item.branch.length > 0) ? _c('i', {
                staticClass: "material-icons showHide"
              }, [_vm._v("arrow_downward")]) : _vm._e(), _vm._v(_vm._s(props.item.label))]) : _c('td', {
                attrs: {
                  "width": "45%"
                },
                on: {
                  "click": function($event) {
                    props.expanded = !props.expanded
                  }
                }
              }, [(props.item.branch.length > 0) ? _c('i', {
                staticClass: "material-icons showHide"
              }, [_vm._v("arrow_forward")]) : _vm._e(), _vm._v(_vm._s(props.item.label))]), _vm._v(" "), _c('td', {
                attrs: {
                  "width": "20%"
                }
              }, [_vm._v(_vm._s(props.item.contactno))]), _vm._v(" "), _c('td', {
                attrs: {
                  "width": "20%"
                }
              }, [_vm._v(_vm._s(props.item.email))]), _vm._v(" "), _c('td', {
                attrs: {
                  "width": "10%"
                }
              }, [_c('v-menu', {
                attrs: {
                  "offset-y": ""
                }
              }, [_c('v-toolbar-side-icon', {
                attrs: {
                  "slot": "activator"
                },
                slot: "activator"
              }), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
                on: {
                  "click": function($event) {
                    $event.preventDefault();
                    return _vm.fncLinkUsers(props.item.id)
                  }
                }
              }, [_c('v-list-tile-title', [(_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('a', [_vm._v("Link Users")]) : _vm._e()])], 1), _vm._v(" "), _c('v-list-tile', {
                on: {
                  "click": function($event) {
                    $event.preventDefault();
                    return _vm.fncEditPricelist(props.item.id)
                  }
                }
              }, [_c('v-list-tile-title', [(_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('a', [_vm._v("Link User Pricelists")]) : _vm._e()])], 1), _vm._v(" "), _c('v-list-tile', {
                on: {
                  "click": function($event) {
                    $event.preventDefault();
                    return _vm.fncEditPassword(props.item.id, props.item.email)
                  }
                }
              }, [_c('v-list-tile-title', [(_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('a', [_vm._v("Update Password")]) : _vm._e()])], 1), _vm._v(" "), _c('v-list-tile', {
                on: {
                  "click": function($event) {
                    $event.preventDefault();
                    return _vm.fncEditNotifications(props.item.id)
                  }
                }
              }, [_c('v-list-tile-title', [(_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('a', [_vm._v("Communication Settings")]) : _vm._e()])], 1), _vm._v(" "), _c('v-list-tile', {
                on: {
                  "click": function($event) {
                    $event.preventDefault();
                    return _vm.fncViewUser(props.item.id, props.item.region)
                  }
                }
              }, [_c('v-list-tile-title', [(_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('a', [_vm._v("User Details")]) : _vm._e()])], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('td', {
                attrs: {
                  "width": "5%"
                }
              }, [_c('a', {
                on: {
                  "click": function($event) {
                    $event.preventDefault();
                    return _vm.fncEditUser(props.item)
                  }
                }
              }, [_c('i', {
                staticClass: "material-icons"
              }, [_vm._v("edit")])])]) : _vm._e()])]
            }
          }, {
            key: "expand",
            fn: function(props) {
              return [(props.item.branch != '') ? _c('v-data-table', {
                staticClass: "elevation-1 subTable subTable2",
                attrs: {
                  "headers": _vm.headers,
                  "items": props.item.branch,
                  "hide-actions": "",
                  "disable-initial-sort": "",
                  "rows-per-page-items": [20, 40, 60, 80, 100]
                },
                scopedSlots: _vm._u([{
                  key: "items",
                  fn: function(props) {
                    return [_c('tr', [(props.expanded == true) ? _c('td', {
                      attrs: {
                        "width": "45%"
                      },
                      on: {
                        "click": function($event) {
                          props.expanded = !props.expanded
                        }
                      }
                    }, [(props.item.branch.length > 0) ? _c('i', {
                      staticClass: "material-icons showHide"
                    }, [_vm._v("arrow_downward")]) : _vm._e(), _vm._v(_vm._s(props.item.label))]) : _c('td', {
                      attrs: {
                        "width": "45%"
                      },
                      on: {
                        "click": function($event) {
                          props.expanded = !props.expanded
                        }
                      }
                    }, [(props.item.branch.length > 0) ? _c('i', {
                      staticClass: "material-icons showHide"
                    }, [_vm._v("arrow_forward")]) : _vm._e(), _vm._v(_vm._s(props.item.label))]), _vm._v(" "), _c('td', {
                      attrs: {
                        "width": "20%"
                      }
                    }, [_vm._v(_vm._s(props.item.contactno))]), _vm._v(" "), _c('td', {
                      attrs: {
                        "width": "20%"
                      }
                    }, [_vm._v(_vm._s(props.item.email))]), _vm._v(" "), _c('td', {
                      attrs: {
                        "width": "10%"
                      }
                    }, [_c('v-menu', {
                      attrs: {
                        "offset-y": ""
                      }
                    }, [_c('v-toolbar-side-icon', {
                      attrs: {
                        "slot": "activator"
                      },
                      slot: "activator"
                    }), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
                      on: {
                        "click": function($event) {
                          $event.preventDefault();
                          return _vm.fncLinkUsers(props.item.id)
                        }
                      }
                    }, [_c('v-list-tile-title', [(_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('a', [_vm._v("Link Users")]) : _vm._e()])], 1), _vm._v(" "), _c('v-list-tile', {
                      on: {
                        "click": function($event) {
                          $event.preventDefault();
                          return _vm.fncEditPricelist(props.item.id)
                        }
                      }
                    }, [_c('v-list-tile-title', [(_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('a', [_vm._v("Link User Pricelists")]) : _vm._e()])], 1), _vm._v(" "), _c('v-list-tile', {
                      on: {
                        "click": function($event) {
                          $event.preventDefault();
                          return _vm.fncEditPassword(props.item.id, props.item.email)
                        }
                      }
                    }, [_c('v-list-tile-title', [(_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('a', [_vm._v("Update Password")]) : _vm._e()])], 1), _vm._v(" "), _c('v-list-tile', {
                      on: {
                        "click": function($event) {
                          $event.preventDefault();
                          return _vm.fncEditNotifications(props.item.id)
                        }
                      }
                    }, [_c('v-list-tile-title', [(_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('a', [_vm._v("Communication Settings")]) : _vm._e()])], 1), _vm._v(" "), _c('v-list-tile', {
                      on: {
                        "click": function($event) {
                          $event.preventDefault();
                          return _vm.fncViewUser(props.item.id, props.item.region)
                        }
                      }
                    }, [_c('v-list-tile-title', [(_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('a', [_vm._v("User Details")]) : _vm._e()])], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('td', {
                      attrs: {
                        "width": "5%"
                      }
                    }, [_c('a', {
                      on: {
                        "click": function($event) {
                          $event.preventDefault();
                          return _vm.fncEditUser(props.item)
                        }
                      }
                    }, [_c('i', {
                      staticClass: "material-icons"
                    }, [_vm._v("edit")])])]) : _vm._e()])]
                  }
                }, {
                  key: "expand",
                  fn: function(props) {
                    return [(props.item.branch != '') ? _c('v-data-table', {
                      staticClass: "elevation-1 subTable subTable3",
                      attrs: {
                        "items": props.item.branch,
                        "hide-actions": "",
                        "disable-initial-sort": "",
                        "rows-per-page-items": [20, 40, 60, 80, 100]
                      },
                      scopedSlots: _vm._u([{
                        key: "items",
                        fn: function(props) {
                          return [_c('tr', [(props.expanded == true) ? _c('td', {
                            attrs: {
                              "width": "45%"
                            },
                            on: {
                              "click": function($event) {
                                props.expanded = !props.expanded
                              }
                            }
                          }, [(props.item.branch.length > 0) ? _c('i', {
                            staticClass: "material-icons showHide"
                          }, [_vm._v("arrow_downward")]) : _vm._e(), _vm._v(_vm._s(props.item.label))]) : _c('td', {
                            attrs: {
                              "width": "45%"
                            },
                            on: {
                              "click": function($event) {
                                props.expanded = !props.expanded
                              }
                            }
                          }, [(props.item.branch.length > 0) ? _c('i', {
                            staticClass: "material-icons showHide"
                          }, [_vm._v("arrow_forward")]) : _vm._e(), _vm._v(_vm._s(props.item.label))]), _vm._v(" "), _c('td', {
                            attrs: {
                              "width": "20%"
                            }
                          }, [_vm._v(_vm._s(props.item.contactno))]), _vm._v(" "), _c('td', {
                            attrs: {
                              "width": "20%"
                            }
                          }, [_vm._v(_vm._s(props.item.email))]), _vm._v(" "), _c('td', {
                            attrs: {
                              "width": "10%"
                            }
                          }, [_c('v-menu', {
                            attrs: {
                              "offset-y": ""
                            }
                          }, [_c('v-toolbar-side-icon', {
                            attrs: {
                              "slot": "activator"
                            },
                            slot: "activator"
                          }), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
                            on: {
                              "click": function($event) {
                                $event.preventDefault();
                                return _vm.fncLinkUsers(props.item.id)
                              }
                            }
                          }, [_c('v-list-tile-title', [(_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('a', [_vm._v("Link Users")]) : _vm._e()])], 1), _vm._v(" "), _c('v-list-tile', {
                            on: {
                              "click": function($event) {
                                $event.preventDefault();
                                return _vm.fncEditPricelist(props.item.id)
                              }
                            }
                          }, [_c('v-list-tile-title', [(_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('a', [_vm._v("Link User Pricelists")]) : _vm._e()])], 1), _vm._v(" "), _c('v-list-tile', {
                            on: {
                              "click": function($event) {
                                $event.preventDefault();
                                return _vm.fncEditPassword(props.item.id, props.item.email)
                              }
                            }
                          }, [_c('v-list-tile-title', [(_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('a', [_vm._v("Update Password")]) : _vm._e()])], 1), _vm._v(" "), _c('v-list-tile', {
                            on: {
                              "click": function($event) {
                                $event.preventDefault();
                                return _vm.fncEditNotifications(props.item.id)
                              }
                            }
                          }, [_c('v-list-tile-title', [(_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('a', [_vm._v("Communication Settings")]) : _vm._e()])], 1), _vm._v(" "), _c('v-list-tile', {
                            on: {
                              "click": function($event) {
                                $event.preventDefault();
                                return _vm.fncViewUser(props.item.id, props.item.region)
                              }
                            }
                          }, [_c('v-list-tile-title', [(_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('a', [_vm._v("User Details")]) : _vm._e()])], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('td', {
                            attrs: {
                              "width": "5%"
                            }
                          }, [_c('a', {
                            on: {
                              "click": function($event) {
                                $event.preventDefault();
                                return _vm.fncEditUser(props.item)
                              }
                            }
                          }, [_c('i', {
                            staticClass: "material-icons"
                          }, [_vm._v("edit")])])]) : _vm._e()])]
                        }
                      }, {
                        key: "expand",
                        fn: function(props) {
                          return [(props.item.branch != '') ? _c('v-data-table', {
                            staticClass: "elevation-1 subTable subTable4",
                            attrs: {
                              "items": props.item.branch,
                              "hide-actions": "",
                              "disable-initial-sort": "",
                              "rows-per-page-items": [20, 40, 60, 80, 100]
                            },
                            scopedSlots: _vm._u([{
                              key: "items",
                              fn: function(props) {
                                return [_c('tr', [(props.expanded == true) ? _c('td', {
                                  attrs: {
                                    "width": "45%"
                                  },
                                  on: {
                                    "click": function($event) {
                                      props.expanded = !props.expanded
                                    }
                                  }
                                }, [(props.item.branch.length > 0) ? _c('i', {
                                  staticClass: "material-icons showHide"
                                }, [_vm._v("arrow_downward")]) : _vm._e(), _vm._v(_vm._s(props.item.label))]) : _c('td', {
                                  attrs: {
                                    "width": "45%"
                                  },
                                  on: {
                                    "click": function($event) {
                                      props.expanded = !props.expanded
                                    }
                                  }
                                }, [(props.item.branch.length > 0) ? _c('i', {
                                  staticClass: "material-icons showHide"
                                }, [_vm._v("arrow_forward")]) : _vm._e(), _vm._v(_vm._s(props.item.label))]), _vm._v(" "), _c('td', {
                                  attrs: {
                                    "width": "20%"
                                  }
                                }, [_vm._v(_vm._s(props.item.contactno))]), _vm._v(" "), _c('td', {
                                  attrs: {
                                    "width": "20%"
                                  }
                                }, [_vm._v(_vm._s(props.item.email))]), _vm._v(" "), _c('td', {
                                  attrs: {
                                    "width": "10%"
                                  }
                                }, [_c('v-menu', {
                                  attrs: {
                                    "offset-y": ""
                                  }
                                }, [_c('v-toolbar-side-icon', {
                                  attrs: {
                                    "slot": "activator"
                                  },
                                  slot: "activator"
                                }), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
                                  on: {
                                    "click": function($event) {
                                      $event.preventDefault();
                                      return _vm.fncLinkUsers(props.item.id)
                                    }
                                  }
                                }, [_c('v-list-tile-title', [(_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('a', [_vm._v("Link Users")]) : _vm._e()])], 1), _vm._v(" "), _c('v-list-tile', {
                                  on: {
                                    "click": function($event) {
                                      $event.preventDefault();
                                      return _vm.fncEditPricelist(props.item.id)
                                    }
                                  }
                                }, [_c('v-list-tile-title', [(_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('a', [_vm._v("Link User Pricelists")]) : _vm._e()])], 1), _vm._v(" "), _c('v-list-tile', {
                                  on: {
                                    "click": function($event) {
                                      $event.preventDefault();
                                      return _vm.fncEditPassword(props.item.id, props.item.email)
                                    }
                                  }
                                }, [_c('v-list-tile-title', [(_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('a', [_vm._v("Update Password")]) : _vm._e()])], 1), _vm._v(" "), _c('v-list-tile', {
                                  on: {
                                    "click": function($event) {
                                      $event.preventDefault();
                                      return _vm.fncEditNotifications(props.item.id)
                                    }
                                  }
                                }, [_c('v-list-tile-title', [(_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('a', [_vm._v("Communication Settings")]) : _vm._e()])], 1), _vm._v(" "), _c('v-list-tile', {
                                  on: {
                                    "click": function($event) {
                                      $event.preventDefault();
                                      return _vm.fncViewUser(props.item.id, props.item.region)
                                    }
                                  }
                                }, [_c('v-list-tile-title', [(_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('a', [_vm._v("User Details")]) : _vm._e()])], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('td', {
                                  attrs: {
                                    "width": "5%"
                                  }
                                }, [_c('a', {
                                  on: {
                                    "click": function($event) {
                                      $event.preventDefault();
                                      return _vm.fncEditUser(props.item)
                                    }
                                  }
                                }, [_c('i', {
                                  staticClass: "material-icons"
                                }, [_vm._v("edit")])])]) : _vm._e()])]
                              }
                            }, {
                              key: "expand",
                              fn: function(props) {
                                return [(props.item.branch != '') ? _c('v-data-table', {
                                  staticClass: "elevation-1 subTable subTable5",
                                  attrs: {
                                    "items": props.item.branch,
                                    "hide-actions": "",
                                    "disable-initial-sort": "",
                                    "rows-per-page-items": [20, 40, 60, 80, 100]
                                  },
                                  scopedSlots: _vm._u([{
                                    key: "items",
                                    fn: function(props) {
                                      return [_c('tr', [(props.expanded == true) ? _c('td', {
                                        attrs: {
                                          "width": "45%"
                                        },
                                        on: {
                                          "click": function($event) {
                                            props.expanded = !props.expanded
                                          }
                                        }
                                      }, [(props.item.branch.length > 0) ? _c('i', {
                                        staticClass: "material-icons showHide"
                                      }, [_vm._v("arrow_downward")]) : _vm._e(), _vm._v(_vm._s(props.item.label))]) : _c('td', {
                                        attrs: {
                                          "width": "45%"
                                        },
                                        on: {
                                          "click": function($event) {
                                            props.expanded = !props.expanded
                                          }
                                        }
                                      }, [(props.item.branch.length > 0) ? _c('i', {
                                        staticClass: "material-icons showHide"
                                      }, [_vm._v("arrow_forward")]) : _vm._e(), _vm._v(_vm._s(props.item.label))]), _vm._v(" "), _c('td', {
                                        attrs: {
                                          "width": "20%"
                                        }
                                      }, [_vm._v(_vm._s(props.item.contactno))]), _vm._v(" "), _c('td', {
                                        attrs: {
                                          "width": "20%"
                                        }
                                      }, [_vm._v(_vm._s(props.item.email))]), _vm._v(" "), _c('td', {
                                        attrs: {
                                          "width": "10%"
                                        }
                                      }, [_c('v-menu', {
                                        attrs: {
                                          "offset-y": ""
                                        }
                                      }, [_c('v-toolbar-side-icon', {
                                        attrs: {
                                          "slot": "activator"
                                        },
                                        slot: "activator"
                                      }), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
                                        on: {
                                          "click": function($event) {
                                            $event.preventDefault();
                                            return _vm.fncLinkUsers(props.item.id)
                                          }
                                        }
                                      }, [_c('v-list-tile-title', [(_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('a', [_vm._v("Link Users")]) : _vm._e()])], 1), _vm._v(" "), _c('v-list-tile', {
                                        on: {
                                          "click": function($event) {
                                            $event.preventDefault();
                                            return _vm.fncEditPricelist(props.item.id)
                                          }
                                        }
                                      }, [_c('v-list-tile-title', [(_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('a', [_vm._v("Link User Pricelists")]) : _vm._e()])], 1), _vm._v(" "), _c('v-list-tile', {
                                        on: {
                                          "click": function($event) {
                                            $event.preventDefault();
                                            return _vm.fncEditPassword(props.item.id, props.item.email)
                                          }
                                        }
                                      }, [_c('v-list-tile-title', [(_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('a', [_vm._v("Update Password")]) : _vm._e()])], 1), _vm._v(" "), _c('v-list-tile', {
                                        on: {
                                          "click": function($event) {
                                            $event.preventDefault();
                                            return _vm.fncEditNotifications(props.item.id)
                                          }
                                        }
                                      }, [_c('v-list-tile-title', [(_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('a', [_vm._v("Communication Settings")]) : _vm._e()])], 1), _vm._v(" "), _c('v-list-tile', {
                                        on: {
                                          "click": function($event) {
                                            $event.preventDefault();
                                            return _vm.fncViewUser(props.item.id, props.item.region)
                                          }
                                        }
                                      }, [_c('v-list-tile-title', [(_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('a', [_vm._v("User Details")]) : _vm._e()])], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('td', {
                                        attrs: {
                                          "width": "5%"
                                        }
                                      }, [_c('a', {
                                        on: {
                                          "click": function($event) {
                                            $event.preventDefault();
                                            return _vm.fncEditUser(props.item)
                                          }
                                        }
                                      }, [_c('i', {
                                        staticClass: "material-icons"
                                      }, [_vm._v("edit")])])]) : _vm._e()])]
                                    }
                                  }], null, true)
                                }) : _vm._e()]
                              }
                            }], null, true)
                          }) : _vm._e()]
                        }
                      }], null, true)
                    }) : _vm._e()]
                  }
                }], null, true)
              }) : _vm._e()]
            }
          }], null, true)
        }) : _vm._e()]
      }
    }], null, false, 3322055297)
  }) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}